import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import { togglePopup } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import InputCaptcha from 'apps/auth/components/form/InputCaptcha';
import InputPassword from 'apps/auth/components/form/InputPassword';
import Form from 'apps/auth/components/form-multi/Form';
import { getCaptchaURL } from 'apps/auth/components/form-multi/utils';
import Loading from 'apps/auth/components/utils/Loading';
import { SECURITY_CHECK_URL } from 'apps/auth/constants/UrlConstants';

import ExpiredPasswordInfoModal from './ExpiredPasswordInfoModal';
import ForgotPopup from './ForgotPopup';

const InsertPassword = (props) => {
    const [captchaURL, setCaptchaUrl] = useState(getCaptchaURL());
    const submitRef = useRef(null);
    useEffect(() => {
        if (props.login_failure_component && props.login_failure_component.errorCount > 3) {
            setCaptchaUrl(getCaptchaURL());
        }
    }, [props.login_failure_component]);

    const passIsFilled = () => {
        return !(props.fields.password.value && props.fields.password.value.length >= 1 && !props.fields.password.isError);
    };

    const buttons = () => {
        return (
            <FixedBottomPanel isRightAligned={true}>
                <Button type="submit" raised={true} size="fit" caption={props.button} ref={submitRef} disabled={passIsFilled()} />
            </FixedBottomPanel>
        );
    };

    const onSubmitHandler = (fields, json) => {
        if (json.extra?.login_failure_component?.passwordExpired) {
            props.popupRef.current?.open(
                <ExpiredPasswordInfoModal
                    setScreen={props.setScreen}
                    mainText={json.extra.login_failure_component.errorText}
                    ref={submitRef}
                    popupRef={props.popupRef}
                />,
            );
        }
    };

    if (!props.fields) {
        return (
            <BaseLayout showChat={false}>
                <Loading />
            </BaseLayout>
        );
    }
    return (
        <>
            <HeaderPanel title={props.headerTitle} subtitle={props.headerGrayTitle} />
            <Form formName={props.formName} onSubmitHandler={onSubmitHandler} action={SECURITY_CHECK_URL} checkNotVisibleField={false} buttons={buttons()}>
                <fieldset>
                    <fieldset>
                        <InputPassword field={props.fields.password} formName={props.formName} focus={true} />
                    </fieldset>
                    {props.login_failure_component && props.login_failure_component.errorCount >= 3 && (
                        <fieldset className="line-1">
                            <InputCaptcha formName={props.formName} captchaURL={captchaURL} field={props.fields.captcha} />
                        </fieldset>
                    )}
                    <fieldset className="text-center">
                        <Button
                            dataTestId="button-check-user-phone"
                            type="button"
                            variant="secondary"
                            onClick={(e) => {
                                e.preventDefault();
                                props.togglePopup(true, <ForgotPopup formName={props.formName} submitRef={submitRef} />);
                            }}
                            caption={props.passwordForgotBtn}
                        />
                    </fieldset>
                </fieldset>
            </Form>
        </>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        fields: state.form[ownProps.formName].fields,
        button: state.messages.pageMessages.button,
        passwordForgotBtn: state.messages.pageMessages.passwordForgotBtn,
        login_failure_component: state.extra.login_failure_component,
        headerTitle: state.messages.pageMessages.headerTitleInsertPassword,
        headerGrayTitle: state.messages.pageMessages.headerGrayTitleInsertPassword,
        country: state.app?.country,
        lang: state.language?.lang,
    };
};
export default connect(mapStateToProps, { togglePopup })(InsertPassword);
